/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'ArticleRelationPrice'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('articlerelationprice'); // main translation loaded for articlerelationprice
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/articlerelationprice/articlerelationprice-dialog.html';

		return {
			/* new state for entity articleRelationPrice */
			/* to access: ui-ref="articlerelationprice.list.new" */
			/* url: hostname/articlerelationprice/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'ArticleRelationPriceDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'ArticleRelationPriceFactory',
									'NewArticleRelationPriceFactory',
									function(ArticleRelationPriceFactory, NewArticleRelationPriceFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new ArticleRelationPrice
										// - resuming the creation of a new new ArticleRelationPrice AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return ArticleRelationPriceFactory.get({ id: $stateParams.articleRelationPriceId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewArticleRelationPriceFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for articleRelationPrice new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for articleRelationPrice edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('articlerelationprice', {
		/* abstract state for entity articleRelationPrice */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/articlerelationprice',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'ArticleRelationPrices',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('articlerelationprice.list', {
		/* list state for entity articleRelationPrice */
		/* to access: ui-ref="articlerelationprice.list" */
		/* url: hostname/articlerelationprice/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/articlerelationprice/articlerelationprices.html',
				controller: 'ArticleRelationPriceController',
			},
		},
	});

	$stateProvider.state('articlerelationprice.detail', {
		/* detail state for entity articleRelationPrice */
		/* to access: ui-sref="articlerelationprice.detail" */
		/* url: hostname/articlerelationprice/detail/:articleRelationPriceId */
		url: '/detail/:articleRelationPriceId',
		views: {
			'content@': {
				templateUrl: 'app/entities/articlerelationprice/articlerelationprice-detail.html',
				controller: 'ArticleRelationPriceDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'ArticleRelationPriceFactory',
				function($stateParams, ArticleRelationPriceFactory) {
					return ArticleRelationPriceFactory.get({ id: $stateParams.articleRelationPriceId });
				},
			],
		},
	});

	/* url: http://<hostname>/articlerelationprice/list/new */
	$stateProvider.state('articlerelationprice.list.new', getNewState());
	/* url: http://<hostname>/articlerelationprice/list/:articleRelationPriceId/edit */
	$stateProvider.state('articlerelationprice.list.edit', getEditState('/:articleRelationPriceId/edit'));
	/* url: http://<hostname>/articlerelationprice/detail/:articleRelationPriceId/edit */
	$stateProvider.state('articlerelationprice.detail.edit', getEditState('/edit'));
	// Article.articleRelationPrice with multiplicity 0..n points to ArticleRelationPrice
	/* url: http://<hostname>/article/detail/:articleId/articlerelationprice/new */
	$stateProvider.state('article.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/article/detail/:articleId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('article.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-article/detail/:articleId/articlerelationprice/new */
	$stateProvider.state('user-article.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/user-article/detail/:articleId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('user-article.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Relation.articleRelationPrice with multiplicity 0..n points to ArticleRelationPrice
	/* url: http://<hostname>/relation/detail/:relationId/articlerelationprice/new */
	$stateProvider.state('relation.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/relation/detail/:relationId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('relation.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/articlerelationprice/new */
	$stateProvider.state('user-relation.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('user-relation.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
});
